import { css } from 'styled-components';
import { COLORS } from '../../../../shared/design/tokens';

const styles = {
  addOnItemContainer: css`
    display: flex;
    flex-direction: column;

    border: 1px solid ${COLORS.ADD_ONS.BORDER};
    border-radius: 2px;
    background-color: ${COLORS.ADD_ONS.BACKGROUND};
    padding-top: 40px;
    padding-bottom: ${props =>
      !props.isTextArea && props.showRemove ? '' : '40px'};
    padding-left: 32px;
    padding-right: 32px;
    margin-bottom: 20px;
  `,
  topContainer: css`
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    position: relative;
    margin-bottom: ${props => (props.isTextArea ? '20px' : '24px')};
  `,
  descriptionContainer: css`
    margin-bottom: 16px;
  `,
  removeContainer: css`
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  `,
  removeLabel: css`
    color: ${COLORS.FORM.COLLAPSED.TEXT};
    position: relative;
    cursor: pointer;
    &:after {
      border-bottom: 1.5px dashed ${COLORS.FORM.COLLAPSED.BORDER};
      content: '';
      height: 1px;
      width: 100%;
      position: absolute;
      left: 50%;
      bottom: 5.5px;
      transform: translateX(-50%);
    }

    &:hover {
      opacity: 0.75;
    }
  `,
  button: css`
    margin-bottom: 8px !important;
  `
};

export default styles;
